export default __webpack_public_path__ + "static/media/drive-active.a27e745e.svg";